module.exports = __webpack_public_path__ + "img/kyousei2new.b143650a.jpg";